export const POS_DASHBOARD_GO_BUTTON_ACTION = "POS_DASHBOARD_GO_BUTTON_ACTION";
export const POS_DASHBOARD_GO_BUTTON_SUCCESS = "POS_DASHBOARD_GO_BUTTON_SUCCESS";
export const POS_DASHBOARD_API_ERROR_ACTION = "POS_DASHBOARD_API_ERROR_ACTION";
